export default __webpack_public_path__ + "static/media/card-theme9.774c7517.svg";